/**
 * Granularities
 */
import i18n from '@/plugins/i18n';

export const granularities: string[] = ['hourly', 'daily', 'weekly', 'monthly'];

export default granularities;
